export function formatNumberAsCurrency(amount: number) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
}

export function removeNonNumericChars(text?: string | null): number | null {
  if (!text) return null;
  const numericChars = text.replace(/\D+/g, "");
  if (numericChars.trim().length === 0) return null;
  return parseFloat(numericChars);
}
